import BookmakersPageContainer from './BookmakersPage';

export default BookmakersPageContainer;
